module.exports = __webpack_public_path__ + "static/media/mahan.22c2fb74.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mahan.png
// module id = 233
// module chunks = 0